import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { ICommandTemplate } from "@formant/core/model/ICommandTemplate";

import {
    appStore,
    commandTemplateStore,
    eventTriggerStore,
} from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    commandTemplate: ICommandTemplate;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove command"
                />
            </Buttons>
        );
    }

    private onDelete = async () => {
        const { commandTemplate } = this.props;
        const { name, id } = commandTemplate;
        const eventTriggers = await eventTriggerStore.fetchList();
        const usedBy = eventTriggers.filter(
            eventTrigger =>
                eventTrigger.enabled &&
                eventTrigger.commands.some(_ => _.commandTemplateId === id),
        );
        const message = (
            <>
                {usedBy.length > 0 && (
                    <>
                        <p>
                            This command is in use by {usedBy.length} event
                            {usedBy.length > 1 ? "s" : ""}:
                        </p>
                        <ul>
                            {usedBy.map(({ message: m }, i) => (
                                <li key={i}>{m}</li>
                            ))}
                        </ul>
                        <p>
                            Events will continue to use this command even if it
                            is deleted.
                        </p>
                    </>
                )}
                <p>Delete command "{name}"?</p>
            </>
        );
        appStore.setConfirm({
            title: "Delete command",
            message,
            onOk: async () => {
                await commandTemplateStore.disable(defined(id));
                appStore.setSnackbar("Command deleted");
            },
        });
    };
}
